export default "__VITE_ASSET__10c9707d__"